<template>
  <div class="applyInfoPage">
    <el-card>
      <el-table :data="recruitmentInfo" border style="width: 100%">
        <el-table-column prop="job_name" label="招聘岗位" width="140"> </el-table-column>
        <el-table-column prop="job_condition" label="岗位要求" width="800"> </el-table-column>
        <el-table-column prop="job_count" label="招聘人数" width="90"> </el-table-column>
        <el-table-column label="操作" width="127">
          <template slot-scope="scope">
            <el-button type="success" @click="sureJobHandle(scope.row)">确认报名</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="up" style="height: 8vh;"></div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      recruitmentInfo: []
    }
  },
  // 获取state中的编制和活动id传入
  computed: {
    ...mapState(['bianzhi', 'signup_id', 'getJobList'])
  },
  created() {
      this.getJobLists()
  },
  methods: {
    ...mapMutations({
      stepAdd: 'ADD_STEP',
      setJob: 'SET_ApplyJob',
      setRecid: 'SET_RECID'
    }),
    getJobLists() {
      const loading = this.$loading({})
      const paramsData = {
        signupId: this.$route.query.singupId,
        bianzhi: this.$route.query.bianzhi
      }
      this.$axios
        .get('api/signup/jobList', {
          params: paramsData
        })
        .then(result => {
          loading.close()
          const { data: res } = result
          console.log('list',res)
          this.recruitmentInfo = res.data
          res.data.forEach((val,index) => {
            if(!val.job_condition) {
              // console.log(index)
              this.recruitmentInfo[index].job_condition = "详见岗位及要求一览表"
            }
          })
        })
        .catch(() => {
          loading.close()
        })
    },
    // 点击报名
    sureJobHandle(val) {
      this.setJob(val)
      this.stepAdd()
      this.setRecid(val.rec_id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.el-card {
  margin-top: 25px;
  @include autoInner;
}
.applyInfoPage {
  margin-top: 50px;
  height:calc(100vh - 400px);
 
  .notice {
    padding: 24px;
    p {
      padding: 10px 0;
    }
  }
}
</style>
